/* eslint-disable */
import * as dialogDecoratorImpl from '@bingads-webui-component-legacy/dialog/dialogDecoratorImpl';
export default {
  decorate: dialogDecoratorImpl.decorate
};

